var _circle, _circle2, _circle3, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "url(#paint0_linear_2223_324)",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 50.5,
    stroke: "url(#paint1_linear_2223_324)",
    strokeOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 37.5,
    fill: "url(#paint2_linear_2223_324)",
    fillOpacity: 0.2,
    stroke: "url(#paint3_linear_2223_324)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2223_324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1789 37.82C35 39.7438 35 42.3625 35 47.6V50.6811C35 55.9186 35 58.5374 36.1789 60.4611C36.8385 61.5376 37.7436 62.4426 38.82 63.1023C40.7438 64.2811 43.3625 64.2811 48.6 64.2811H51.6811C53.1054 64.2811 54.3359 64.2811 55.4116 64.2574L63.2984 70.8824C63.9424 71.4233 64.9259 70.9761 64.9414 70.1352L65.2066 55.8157C65.2671 54.6981 65.2785 53.387 65.2806 51.8171L65.2811 51.7902L65.2807 51.7903C65.2811 51.4341 65.2811 51.0647 65.2811 50.6811V47.6C65.2811 42.3625 65.2811 39.7438 64.1023 37.82C63.4426 36.7436 62.5376 35.8385 61.4611 35.1789C59.5374 34 56.9186 34 51.6811 34H48.6C43.3625 34 40.7438 34 38.82 35.1789C37.7436 35.8385 36.8385 36.7436 36.1789 37.82Z",
    fill: "url(#paint4_linear_2223_324)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2223_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5713 44.0702C51.6092 43.0431 50.7868 42.1897 49.7589 42.1897V42.1897C48.7311 42.1897 47.9086 43.0431 47.9466 44.0702L48.2266 51.6526H51.2913L51.5713 44.0702ZM49.7589 56.9259C50.7469 56.9259 51.6273 56.0926 51.6407 55.0441C51.6273 54.0226 50.7469 53.1892 49.7589 53.1892C48.7172 53.1892 47.8637 54.0226 47.8771 55.0441C47.8637 56.0926 48.7172 56.9259 49.7589 56.9259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2223_324",
    x: 35,
    y: 25,
    width: 31.2812,
    height: 48.1185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2223_324"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.979167 0 0 0 0 0.175434 0 0 0 0 0.462037 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2223_324",
    result: "effect2_innerShadow_2223_324"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2223_324",
    x: 46.877,
    y: 40.1897,
    width: 9.76367,
    height: 20.7363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545833 0 0 0 0 0.0864236 0 0 0 0 0.252593 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2223_324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2223_324",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2223_324",
    x1: 89.5058,
    y1: 179.775,
    x2: -36.8088,
    y2: 177.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0630638,
    stopColor: "#1D212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B041E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2223_324",
    x1: 107,
    y1: 106.5,
    x2: -8,
    y2: -8.1635e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C23165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23165",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2223_324",
    x1: 168,
    y1: 124,
    x2: 62.293,
    y2: 165.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0630638,
    stopColor: "#1D212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B041E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2223_324",
    x1: 51,
    y1: 13,
    x2: 51,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C23165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23165",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2223_324",
    x1: 50.1406,
    y1: 34,
    x2: 65.4697,
    y2: 70.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0649"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/ERROR.05ff38b7bad2ddd7b154e2cadc8c6629.svg";
export { ForwardRef as ReactComponent };